import { api } from './client';
import type { Assessment } from './assessment';

export interface ExecTeamSection {
  teamId: string;
  teamName: string;
  assessments: Assessment[];
}

export async function getExecTeams(): Promise<{ teams: ExecTeamSection[] }> {
  const r = await api.get<{ teams: ExecTeamSection[] }>('/exec/teams');
  return r.data;
}
